import React from 'react';
import AtlasV2DorisDoubleDropdownChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisDoubleDropdownChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { useDorisEntityDropdownOptions } from 'src/components/AtlasV2Components/AtlasV2TrafficV2PageComponents/AtlasV2TotalTrafficV2/AtlasV2TotalTrafficDoubleDropdownTopEntity';

const AtlasPriceTopEntityChart = () => {
  const dropdownOptions = useDorisEntityDropdownOptions('sales');

  return (
    <AtlasV2DorisDoubleDropdownChart
      groupByFields={dropdownOptions}
      fields={[
        {
          fieldName: 'retailPrice',
          label: 'Retail Price',
          metricType: 'retailPrice',
          metricTypeDisplay: METRICTYPE.MONEY
        }
      ]}
      queryKey="price_topEntityChart"
      endPoint="sales/GetSalesMetrics"
    />
  );
};
export default AtlasPriceTopEntityChart;
